/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import Grid from "@mui/material/Grid";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Welcome from "./components/Welcome";

// Moralis
import { useMoralis } from "react-moralis";
import AuthUser from "web3ui/AuthUser";
import Card from "assets/theme/components/card";
import VuiTypography from "components/VuiTypography";

function Home() {
  // use moralis to connect wallet
  const { isInitialized, isAuthenticated, account } = useMoralis();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <VuiBox py={3}>
          {isInitialized && isAuthenticated && account ? (
            <AuthUser />
          ) : (
            <VuiBox textAlign="center">
              <VuiTypography color="white" variant="h5" fontWeight="bold">
                Connect your wallet to see the magic!
              </VuiTypography>
            </VuiBox>
          )}
        </VuiBox>
      </VuiBox>
      <VuiBox>
        <Welcome />
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Home;
